// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c5e00927","455":"1af2a0df"}[chunkId] + ".chunk.js";
};